<template>
	<div  class='tw-flex tw--mx-10'>
		<p-card class="tw-w-full tw-flex tw-gap-2">
			<div class="px-3 tw-w-2/3">
				<h2 class="uppercase" :style="`color:${$appColors.info}`">Datos Generales</h2>
				<label class="tw-flex tw-flex-col tw-justify-start tw-items-start tw-py-3" :style="`color:${$appColors.info}`">
					Tipo de Datos Generales:
				</label>
				<div class="tw-flex tw-justify-start tw-items-center tw-w-72">
					<v-select
						outline
						single-line
						hide-details
						class="select-core"
						:items="typeGeneralData"
						item-value="id"
						item-text="name"
						return-object
						v-model="typeData"
						@input="getTypeData($event)"
						>
					</v-select>
					<v-menu
						offset-x
						rigth
						:nudge-rigth="97"
						max-height="300"
						fixed
						content-class="columns-menu"
						class="options-menu">
							<button
								color="transparent"
								slot="activator">
								<v-tooltip top>
								<img
									src="/static/img/ellipsis.svg"
									alt=""
									slot="activator"
									class="align-img tw-pl-6"
									height="20">
									<span>Ver más</span>
								</v-tooltip>
							</button>
						<v-list>
							<v-list-tile>
								<v-list-tile-title class="tw-pb-10">
									<app-tooltip-button
										img="/static/img/plus.svg"
										text="Agregar Tipo de Dato General"
										@click-icon="addTypeData"
									/>
								</v-list-tile-title>
								<v-list-tile-title class="tw-pb-10">
									<app-tooltip-button
										:img="`${$imageUrl}/edit.svg`"
										text="Editar Tipo de Dato General"
										:disabled="!disabledBtn"
										@click-icon="editTypeData"
									/>
								</v-list-tile-title>
								<v-list-tile-title class="tw-pb-10">
									<app-tooltip-button
										:img="`${$imageUrl}/delete-button.svg`"
										text="Eliminar Tipo de Dato General"
										:disabled="!disabledBtn"
										@click-icon="deleteTypeData"
									/>
								</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu>
				</div>
				<app-table
				class="mt-3 no-main-list"
				:columns="columns"
				:filter-columns="false"
				:main-list="true"
				:rows="generalData"
				btn-actions
				:items-quantity="generalData.length"
				:items-total-quantity="totalItems"
				:current-page="currentPage"
				:last-page="lastPage"
				@on-page="changePage"
				@on-search-event="onSearchEvent"
				@changeSort="changeSort"
				@changeColor="changeColor"
				>
				<template slot="action">
					<app-button
						:disabled="!disabledBtn"
						class="btn-tool"
						icon="add"
						:style="`background-color:${$appColors.primary}`"
						@click="addItemToDataGeneral"
					/>
				</template>
					<template slot="rows" slot-scope="props">
						<td style="text-align: left; padding-left: 40px; width: 68%;" v-show="showRow(columns, 1)">{{ props.row.name }}</td>
						<td v-show="showRow(columns, 2)">
							<template>
								<app-tooltip-button
									:img="`${$imageUrl}/edit.svg`"
									text="Editar"
									@click-icon="editItemCategory(props.row)"
								/>
								<app-tooltip-button
									v-if="props.row.details && props.row.details.length !== 0"
									img="/static/img/eye.svg"
									text="Ver Detalles"
									@click-icon="setDataRow(props.row)"
								/>
								<app-tooltip-button
									img="/static/img/plus.svg"
									size="20"
									text="Subcategorias"
									@click-icon="addSubCategory(props.row)"
								/>
								<app-tooltip-button
									:img="`${$imageUrl}/delete-button.svg`"
									text="Eliminar"
									@click-icon="onDeleteCategory(props.row)"
								/>
							</template>
						</td>
					</template>
				</app-table>
			</div>
			<div class="px-3 tw-w-1/3">
				<app-table
				v-if="detailsLength"
				class=" no-main-list"
				style="padding-top: 120px;"
				:columns="columnsS"
				:filter-columns="false"
				:main-list="true"
				:rows="dataSubcategory"
				btn-actions
				:items-quantity="dataSubcategory.length"
				:items-total-quantity="totalItemsS"
				:current-page="currentPageS"
				:last-page="lastPageS"
				@on-page="changePageS"
				@on-search-event="onSearchEventS"
				@changeSort="changeSortS"
				@changeColor="changeColorS"
				>
					<template slot="rows" slot-scope="props">
						<td style="text-align: left; width: 65%; padding-left: 40px;" v-show="showRow(columns, 1)">{{ props.row.name }}</td>
						<td v-show="showRow(columns, 2)">
							<template>
								<app-tooltip-button
									:img="`${$imageUrl}/edit.svg`"
									text="Editar"
									@click-icon="editSubCategory(props.row)"
								/>
								<app-tooltip-button
									:img="`${$imageUrl}/delete-button.svg`"
									text="Eliminar"
									@click-icon="onDeleteSubcategory(props.row)"
								/>
							</template>
						</td>
					</template>
				</app-table>
			</div>
		</p-card>
		<add-new-item-dialog
			ref="addNewVerb"
			:verb-p="verb"
			:category="dataRow"
			@addNewVerb="saveNewVerb">
		</add-new-item-dialog>
		<edit-subcategory-dialog
			v-if="itemToEdit"
			ref="editSubcategory"
			:data-row="itemToEdit"
			:type-data="typeData"
			:category-data="itemToEdit.flagCategory ? typeGeneralData : generalData"
			@editItem="saveEditItem">
		</edit-subcategory-dialog>
		<add-data-general-to-type-data-dialog
			v-if="typeData"
			ref="addDataGeneralToTypeData"
			:type-data="typeData"
			@addNewItem="saveNewItem">
		</add-data-general-to-type-data-dialog>
		<add-type-data-dialog
			v-if="isVisible"
			:is-visible="isVisible"
			:type-data="typeDataToEdit"
			@addNewItem="handlerItem">
		</add-type-data-dialog>
		<p-confirm-dialog ref="confirmDialog" />
	</div>
</template>

<script>
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import ConfirmDialog from '@/modules/shared/components/ui/ConfirmDialog';
import addNewItemDialog from '@/components/configuration/general-data/add-new-item-dialog';
import editSubcategoryDialog from '@/components/configuration/general-data/edit-subcategory-dialog';
import addDataGeneralToTypeDataDialog from '@/components/configuration/general-data/add-data-general-to-type-data-dialog';
import addTypeDataDialog from '@/components/configuration/general-data/add-type-data-dialog';
import appButton from '@/components/shared/app-button';
import PConfirmDialog from '@/modules/shared/components/ui/p-confirm-dialog';

export default {
	name: 'general-data',
	created() {
		this.loadData();
	},
	data() {
		return {
			typeGeneralData: [],
			generalData: [],
			typeData: {},
			columns: [
				{
					id: 1,
					name: 'Nombre',
					value: 'name',
					visible: true,
					checked: true,
					sortCheck: true,
					fieldName: 'name',
					color: 'gray',
				},
				{
					id: 2,
					name: 'Acciones',
					value: 'actions',
					visible: true,
				},
			],
			columnsS: [
				{
					id: 1,
					name: 'Nombre',
					value: 'name',
					visible: true,
					checked: true,
					sortCheck: true,
					fieldName: 'name',
					color: 'gray',
				},
				{
					id: 2,
					name: 'Acciones',
					value: 'actions',
					visible: true,
				},
			],
			params: {
				limit: 5,
				page: 1,
			},
			paramsS: {
				limit: 5,
				page: 1,
			},
			currentPage: 1,
			totalItems: 0,
			lastPage: 1,
			currentPageS: 1,
			totalItemsS: 0,
			lastPageS: 1,
			dataSubcategory: [],
			dataRow: null,
			verb: { name: null },
			detailsLength: false,
			itemToEdit: {},
			typeDataToEdit: {},
			isVisible: false,
		};
	},
	components: {
		PButton,
		PHorizontalDivider,
		PCard,
		ConfirmDialog,
		addNewItemDialog,
		editSubcategoryDialog,
		addDataGeneralToTypeDataDialog,
		addTypeDataDialog,
		PConfirmDialog,
		appButton,
	},
	methods: {
		async loadData() {
			try {
				const { data: response } = await this.$httpPraktiko.get('type-general');
				this.typeGeneralData = response;
			} catch (error) {
				this.showGenericError();
			}
		},
		async loadDataGeneral() {
			const code = this.typeData.code;
			const params = { ...this.params };
			try {
				const { data: response, headers } = await this.$httpPraktiko.get(`general-data/${code}`, { params });
				this.generalData = response;
				this.lastPage = Number(headers['x-last-page']);
				this.totalItems = Number(headers['x-quantity']);
			} catch (error) {
				this.showGenericError();
			}
		},
		getTypeData(typeData) {
			this.typeData = typeData;
			this.isVisible = false;
			this.loadDataGeneral();
		},
		async viewSubcategories() {
			const params = { ...this.paramsS };
			try {
				const { data: response, headers } = await this.$httpPraktiko.get(`general-data/subcategory/${this.dataRow.id}`, { params });
				this.dataSubcategory = response;
				this.lastPageS = Number(headers['x-last-page']);
				this.totalItemsS = Number(headers['x-quantity']);
			} catch (error) {
				this.showGenericError();
			}
		},
		changeColor(fieldName) {
			this.columns.forEach((c, index) => {
				if (c.fieldName !== fieldName && c.color) {
					this.$set(this.columns, index, { ...c, color: 'gray' });
				}
			});
		},
		changeSort({ fieldName, sortDirection }) {
			this.params.sortField = fieldName;
			this.params.sortDirection = sortDirection;
			this.loadDataGeneral();
		},
		changePage(page) {
			this.params.page = page;
			this.currentPage = page;
			this.loadDataGeneral();
		},
		onSearchEvent(search) {
			this.params.search = search.trim() || null;
			this.changePage(1);
		},
		changeColorS(fieldName) {
			this.columnsS.forEach((c, index) => {
				if (c.fieldName !== fieldName && c.color) {
					this.$set(this.columnsS, index, { ...c, color: 'gray' });
				}
			});
		},
		changeSortS({ fieldName, sortDirection }) {
			this.paramsS.sortField = fieldName;
			this.paramsS.sortDirection = sortDirection;
			this.viewSubcategories();
		},
		changePageS(page) {
			this.paramsS.page = page;
			this.currentPageS = page;
			this.viewSubcategories();
		},
		onSearchEventS(search) {
			this.paramsS.search = search.trim() || null;
			this.changePageS(1);
		},
		setDataRow(row) {
			this.dataRow = row;
			this.viewSubcategories();
		},
		addSubCategory(rowAdd) {
			this.dataRow = rowAdd;
			this.$refs.addNewVerb.open();
		},
		async saveNewVerb(verb) {
			const codeCategory = verb.code.toLowerCase();
			const body = {
				name: verb.name,
				code: `${codeCategory}${verb.name}`,
				description: verb.name,
				subCategory: true,
				companyId: this.dataRow.id,
			};
			try {
				await this.$httpPraktiko.post('general-data', body);
				this.showNotification('Verbo Agregado Correctamente');
				this.viewSubcategories();
				this.verb.name = null;
			} catch (error) {
				if (error.status === 400) {
					if (error.data.message === 'CODE_ALREADY_EXIST') {
						this.showNotification('Título ya existente', 'warning');
					} else {
						this.showGenericError();
					}
				}
			}
		},
		async saveNewItem(itemAdd) {
			const body = {
				name: itemAdd.name,
				code: itemAdd.code,
				description: itemAdd.name,
				subCategory: false,
				typeGeneralId: this.typeData.id,
			};
			if (itemAdd.urlLogo !== null) {
				body.urlLogo = itemAdd.urlLogo;
			}
			if (itemAdd.urlPlatform !== null) {
				body.urlPlatform = itemAdd.urlPlatform;
			}
			try {
				await this.$httpPraktiko.post('general-data', body);
				this.showNotification(`Item Agregado a ${this.typeData.name}`);
				this.loadDataGeneral();
			} catch (error) {
				this.showGenericError();
			}
		},
		async saveEditItem(itemEdit) {
			const body = {
				name: itemEdit.name,
				code: itemEdit.flagCategory ? itemEdit.code : itemEdit.name,
				description: itemEdit.name,
				subCategory: !itemEdit.flagCategory,
				typeGeneralId: itemEdit.flagCategory ? itemEdit.category : null,
				companyId: !itemEdit.flagCategory ? itemEdit.category : null,
			};
			if (itemEdit.urlLogo !== null) {
				body.urlLogo = itemEdit.urlLogo;
			}
			if (itemEdit.urlPlatform !== null) {
				body.urlPlatform = itemEdit.urlPlatform;
			}
			try {
				await this.$httpPraktiko.patch(`general-data/${this.itemToEdit.id}`, body);
				this.showNotification('Item Editado Correctamente');
				if (itemEdit.flagCategory) {
					this.loadDataGeneral();
				} else {
					this.viewSubcategories();
				}
			} catch (error) {
				this.showGenericError();
			}
		},
		editSubCategory(row) {
			this.itemToEdit = row;
			this.itemToEdit.flagCategory = false;
			this.$refs.editSubcategory.open();
		},
		onDeleteSubcategory(row) {
			this.$refs.confirmDialog.showConfirm({
				onOk: async () => {
					try {
						const params = {
							subCategory: true,
						};
						await this.$httpPraktiko.delete(`general-data/${row.id}`, { params });
						this.showNotification('Item Eliminado Exitosamente');
						this.viewSubcategories();
					} catch (error) {
						this.showGenericError();
					}
				},
				title: `¿Seguro que desea eliminar "${row.name}" de la lista?`,
			});
		},
		onDeleteCategory(row) {
			this.$refs.confirmDialog.showConfirm({
				onOk: async () => {
					try {
						const params = {
							subCategory: false,
						};
						await this.$httpPraktiko.delete(`general-data/${row.id}`, { params });
						this.showNotification('Item Eliminado Exitosamente');
						this.loadDataGeneral();
					} catch (error) {
						this.showGenericError();
					}
				},
				title: `¿Seguro que desea eliminar "${row.name}" de la lista de ${this.typeData.name}?. Ten en cuenta que se eliminaran las Subcategorias que esta contenga`,
			});
		},
		addItemToDataGeneral() {
			this.$refs.addDataGeneralToTypeData.open();
		},
		editItemCategory(row) {
			this.itemToEdit = row;
			this.itemToEdit.flagCategory = true;
			this.$refs.editSubcategory.open();
		},
		addTypeData() {
			this.typeDataToEdit = {};
			this.typeDataToEdit.flagEdit = false;
			this.isVisible = true;
		},
		async editTypeData() {
			try {
				if (Object.keys(this.typeData).length !== 0) {
					const { data: response } = await this.$httpPraktiko.get(`type-general/${this.typeData.id}/detail`);
					this.typeDataToEdit = response;
					this.typeDataToEdit.flagEdit = true;
					this.isVisible = true;
					this.typeData = {};
				} else {
					this.showNotification('Seleccione un Tipo de Dato General', 'warning');
				}
			} catch (error) {
				this.showGenericError();
			}
		},
		deleteTypeData() {
			this.$refs.confirmDialog.showConfirm({
				onOk: async () => {
					try {
						await this.$httpPraktiko.delete(`type-general/delete/${this.typeData.id}`);
						this.showNotification('Item Eliminado Exitosamente');
						this.typeData = {};
						this.isVisible = false;
						this.loadData();
					} catch (error) {
						this.showGenericError();
					}
				},
				title: `¿Seguro que desea eliminar "${this.typeData.name}" de la lista?. Considere que se borrarán las categorias y subcategorias que este contenga.`,
			});
		},
		async handlerItem(item) {
			this.typeData.name = item.name;
			const body = {
				name: item.name,
				code: item.code,
			};
			const method = item.flagEdit ? 'patch' : 'post';
			const url = item.flagEdit ? `type-general/${this.typeDataToEdit.id}` : 'type-general';
			const action = item.flagEdit ? 'edito' : 'creó';
			try {
				await this.$httpPraktiko[method](url, body);
				this.showNotification(`Se ${action} correctamente`);
				this.loadData();
				this.isVisible = false;
			} catch (error) {
				this.showGenericError();
			}
		},
	},
	computed: {
		disabledBtn() {
			return Object.keys(this.typeData).length > 0;
		},
	},
	watch: {
		generalData: {
			handler(newVal) {
				this.detailsLength = newVal.some(obj => obj.details.length > 0);
				this.dataSubcategory = [];
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.btn-tool {
	border-radius: 4px;
	color: white;
	font-family: font(bold);
	height: 34px;
	padding: 5px 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/configuration/general-data.vue